import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {DeviceType} from "../../model/device-type.model";
import {Device} from "../../model/device.model";
import {DeviceService} from "../device.service";
import {ActivatedRoute, Router} from "@angular/router";
import {MatDialog} from "@angular/material/dialog";
import {UtilService} from "../../shared/util.service";
import {DeviceInfoDialogComponent} from "../device-info-dialog/device-info-dialog.component";
import {DeviceInfo} from "../../model/device-info.model";

@Component({
    selector: 'app-device-edit',
    templateUrl: './device-edit.component.html',
    standalone: false
})
export class DeviceEditComponent implements OnInit, OnChanges {

  @Input() device: Device;
  @Input() types: DeviceType[];
  @Input() configs = [];

  showOldAttributeView = false;
  newItem = true;

  allInfo :any = [];

  activeInput: DeviceInfo = null;
  writeList: DeviceInfo[] = [];

  constructor(
    private service: DeviceService,
    private router: Router,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private util: UtilService
  ) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges) {
    // Device changed, init again the page
    if (changes.device) {
      this.initPage();
    }
    if (changes.configs) {
      this.extendInfoWithConfig();
    }
  }

  extendInfoWithConfig() {
    if (!this.allInfo || !this.allInfo.length) {
      return;
    }
    if (!this.configs || !this.configs.length) {
      return;
    }
    this.allInfo = this.allInfo.map((info:any) => {
      if (info.config || info.attributeName === "Parser") {
        this.configs.map(conf => {
          if (conf.id == info.config) {
            info.config = conf;
          }
          // match parsers
          if (info.attributeName === "Parser" && conf.id === "parser config") {
            info.config = conf
          }
        })
      }
      return info;
    })
  }

  initPage() {
    this.newItem = !this.device || !this.device.id;

    this.allInfo = this.device.infoList;
    if (this.device && this.device.type && this.device.type.attributes) {
      this.device.type.attributes.forEach(attr => {
        let info = this.device.infoList.find(i => i.attribute == attr.id);
        if (!info) {
          this.allInfo.push(new DeviceInfo({attribute: attr.id, attributeName: attr.name, device: this.device.id, config: attr.config ? attr.config : null}))
        }
      })
    }

    if (this.configs && this.configs.length) {
      this.extendInfoWithConfig();
    }
  }

  saveDevice() {
    if (!this.device.isValid()) {
      return this.service.notiService.open('Fill every required field.');
    }
    this.service.saveDevice(this.device, this.newItem).subscribe((resp:any) => {
      if (resp.error) {
        return this.service.notiService.open(resp.error);
      }
      this.service.notiService.open('Mentve');
      if (this.newItem) {
        this.device = new Device(resp);
        this.newItem = false;
        this.router.navigate(['/device', resp.id]);
      }
    })
  }

  handleDeviceDelete() {
    this.service.deleteDevice(this.device.id).subscribe((resp:any) => {
      if (resp.success) {
        this.service.notiService.open("Sikeres törlés");
        return this.router.navigate(['/device']);
      }
    })
  }

  deleteDevice() {
    this.service.confirmAction("Biztosan törlöd ezt az eszközt?").subscribe((isConfirm: boolean) => {
      if (isConfirm) {
        this.handleDeviceDelete()
      }
    })
  }

  compareObjects(o1: any, o2: any): boolean {
    return o1 && o2 && o1.id && o2.id && +o1.id === +o2.id;
  }

  onClickDialogBtn(info?) {
    let isEdit = info && info.id;
    const dialogRef = this.dialog.open(DeviceInfoDialogComponent, {
      data: {
        item: info ? Object.assign(new DeviceInfo(), info) : new DeviceInfo({device: this.device.id}),
        isEdit: isEdit,
        configs: this.configs,
        options: this.device.type.attributes
      },
      minWidth: '300px',
      maxWidth: '500px'
    });

    dialogRef.afterClosed().subscribe( (result: DeviceInfo) => {
      if (result) {
        if (isEdit) {
          this.device.infoList = this.util.findAndReplaceItemInArray(result, this.device.infoList);
        } else {
          this.device.infoList.push(result);
        }
      }
    });
  }

  onDeleteInfoClick(info) {
    this.service.confirmAction("Biztos törlöd ezt a tulajdonságot az eszközről?").subscribe((isConfirm: boolean) => {
      if (isConfirm) {
        this.deleteInfo(info);
      }
    })
  }

  deleteInfo(info) {
    this.service.deleteInfo(info.id).subscribe((resp:any) => {
      if (resp.success) {
        this.service.notiService.open("Sikeres törlés");
        this.util.findAndReplaceItemInArray(info, this.device.infoList, true);
      }
    })
  }

  onEditInfoClick(info) {
    this.onClickDialogBtn(info);
  }

  onInputEditStart(info) {
    this.activeInput = Object.assign(new DeviceInfo({}), info);
  }

  onInputEditEnd(info) {
    if (info.value != this.activeInput.value) {
      let index = this.writeList.findIndex(info => info.attributeName === this.activeInput.attributeName);
      if (index > -1) {
        this.writeList = this.util.findAndReplaceItemInArray(info, this.writeList);
      } else {
        this.writeList.push(info);
      }
    }
    this.activeInput = null;
  }

  onSaveAttributeList() {
    if (!this.writeList.length) {
      return this.service.notiService.open("Nothing to save");
    }
    this.service.saveInfoList({list: this.writeList}).subscribe((resp: any) => {
      this.writeList = [];
      if (resp.erros && resp.errors.length) {
        return this.service.notiService.open("Something went wrong during info list saving. Check console log");
      }
      this.service.notiService.open("Successful info list saving");
      resp.list.forEach((item: DeviceInfo) => {
        const index = this.allInfo.findIndex(el => el.attributeName === item.attributeName);
        if (index > -1) {
            Object.assign(this.allInfo[index], item);
        }
      });
    })
  }
}
